import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';

const CampaignListActions = () => {
  const getCampaignAssignment = async (data) => {
    let params = `?to=${data?.to}&include_assigned_by=${data?.include_assigned_by}&fetch_all=${data?.fetch_all}&next_page=${data?.next_page}&search=${data?.search}`;
    let res = await APIService.get(`${Apis.Get_Campaign_Assignment}${params}`);
    if (res.status == 200) return res?.data;
    // return setCampaignList(res?.data);
    else SweetAlert(Labels.Error, 'error');
  };

  const getAllCampaignAssignment = async (fetch_all, page, search) => {
    try {
      const params = `?fetch_all=${fetch_all}&next_page=${page}&search=${search}`;
      const res = await APIService.get(`${Apis.Get_Campaign_Assignment}${params}`);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const downloadSheet = async (campaignId) => {
    try {
      const res = await APIService.get(`${Apis.Download_Campaign_Sheet}${campaignId}/`);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const sendEmail = async (campaignId, email, emailType) => {
    try {
      let url = `${Apis.Campaign_Send_Email}${emailType}/${campaignId}/`;
      if (email) url += `?email=${email}`;
      const res = await APIService.get(url);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getCampaignWiseSummary = async () => {
    try {
      const res = await APIService.get(Apis.Campaign_Wise_Summary);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const addComment = async (campaignId, data) => {
    try {
      const res = await APIService.post(
        `${Apis.Get_Campaign_Assignment}${campaignId}/comment/`,
        data
      );
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getCampaignComments = async (campaignId, relatedTo = 'CAMPAIGN') => {
    try {
      const res = await APIService.get(
        `/v0/ui/website/${campaignId}/comment/?related_to=${relatedTo}`
      );
      return res;
    } catch (err) {
      console.warn(error);
    }
  };

  const addCampaignComment = async (campaignId, commentText) => {
    try {
      const payload = {
        comment: commentText,
        related_to: "CAMPAIGN"
      };
  
      const res = await APIService.post(
        `/v0/ui/website/${campaignId}/comment/`,
        payload
      );
      return res;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };
  



  const getSuspenseData = async (fromDate, toDate) => {
    try {
      const url = `${Apis.Suspense_Leads}?start_date=${fromDate}&end_date=${toDate}`;
      window.open(`${process.env.REACT_APP_API_BASE_URL}${url}`, '_blank');
      const res = await APIService.get(url);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getSuspenseCount = async (fromDate, toDate) => {
    try {
      const format = (d) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getDate()}`;
      const url = `${Apis.Suspense_Lead_Count}?start_date=${format(fromDate)}&end_date=${format(toDate)}`;
      const res = await APIService.get(url);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getAllSuspenseLead = async () => {
    try {
      const res = await APIService.get(Apis.All_Suspense_Leads);
      if (res.status === 200) return res.data;
    } catch (err) {
      SweetAlert(Labels.Error, 'error');
    }
  };

  return {
    getCampaignAssignment,
    getAllCampaignAssignment,
    downloadSheet,
    sendEmail,
    getCampaignWiseSummary,
    addComment,
    getCampaignComments,
    addCampaignComment,
    getSuspenseData,
    getSuspenseCount,
    getAllSuspenseLead,
  };
};
export { CampaignListActions };
